import { BaseTextFieldProps, StandardTextFieldProps, TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { IReactFormHookProps } from 'src/models/interfaces';
import { StyledLabel, StyledTextField,StyledDiv } from './inputTextFieldStyle';
import './style.css';

interface Iprops extends BaseTextFieldProps, IReactFormHookProps {
    labelText?: string
    onChange?: (value: string) => void
    InputProps?: any
    horizentaly?:boolean
    labelClassName?:string
}

const InputTextFieldUI: FC<Iprops> = ({ labelText,horizentaly, register, onChange, validation, name, InputProps,labelClassName, ...props }) => {

    const registerProps = register && name && register(name, validation)
    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        onChange && onChange(e.target.value)
    }


    return (
        <div className={horizentaly?'InputTextFieldUI-horizental':'InputTextFieldUI-vertical'}>
            {labelText && <StyledLabel className= {labelClassName}  >{labelText}</StyledLabel>}
            <StyledTextField
                {...props}
                {...registerProps}
                InputProps={InputProps}
                onChange={onChangeHandler} />
        </div>

    )

}
export default InputTextFieldUI;